import { Injectable } from '@angular/core';
import { Size } from '../../../models/utils/common.interfaces';

@Injectable({ providedIn: 'root' })
export class WindowUtilsService {
  /**
   * Get browser area/size
   */
  getBrowserArea(): Size {
    // Modern browsers
    const width = this.getBrowserWidth();
    const height = this.getBrowserHeight();

    return {
      width,
      height,
      label: `${width}x${height}`
    };
  }

  private getBrowserWidth(): number {
    if (typeof window.innerWidth === 'number') {
      return window.innerWidth;
    }

    if (window.document?.documentElement?.clientWidth) {
      return window.document.documentElement.clientWidth;
    }

    if (window.document?.body?.clientWidth) {
      return window.document.body.clientWidth;
    }

    return 0;
  }

  private getBrowserHeight(): number {
    if (typeof window.innerHeight === 'number') {
      return window.innerHeight;
    }

    if (window.document?.documentElement?.clientHeight) {
      return window.document.documentElement.clientHeight;
    }

    if (window.document?.body?.clientHeight) {
      return window.document.body.clientHeight;
    }

    return 0;
  }

  /** function for window.location */
  location(url: string) {
    window.location.href = url;
  }

  /**
   * Get screen resolution
   */
  getScreenResolution(): Size {
    const width = window.screen.width;
    const height = window.screen.height;

    return {
      width,
      height,
      label: `${width}x${height}`
    };
  }

  /**
   * Wrapper function for window.open
   */
  // Removed 4th parameter replace?:boolean
  open(url: string, target?: string, features?: string) {
    window.open(url, target, features);
  }

  print() {
    window.print();
  }
}
